import { HeadlessButton, Popover } from "@kensho/neo";
import { useState } from "react";

import { UserPresence } from "../../../components/user-presence";
import { ConnectedUser } from "../../../providers/multiplayer-provider";

interface UserPresenceGutterProps {
  users: ConnectedUser[];
}
export function UserPresenceGutter(props: UserPresenceGutterProps) {
  const { users } = props;
  const [showAllUsers, setShowAllUsers] = useState(false);

  return (
    <div className="mt-9 flex w-16 flex-none cursor-default justify-center -space-x-2 bg-white select-none">
      {users.slice(0, 2).map((user) => (
        <UserPresence user={user} isFollowing={false} size="small" />
      ))}
      {users.length > 2 && (
        <Popover
          content={
            <div className="flex flex-col gap-2 p-4">
              {users.map((user: ConnectedUser) => (
                <UserPresence
                  user={user}
                  isDetailed
                  enablePopover={false}
                  size="small"
                />
              ))}
            </div>
          }
          isOpen={showAllUsers}
          onOpenChange={setShowAllUsers}
        >
          <HeadlessButton>
            <div className="flex h-6 w-6 items-center justify-center rounded-full border border-gray-200 bg-white text-xs">
              {users.length - 2}
            </div>
          </HeadlessButton>
        </Popover>
      )}
    </div>
  );
}
